module.exports = __webpack_public_path__ + "static/media/PictoHabitaculo_2pt.114c3975.svg";